(function () {
  'use strict';

  var PAGE_SELECTOR =
    '[data-lux-product-page]';


  /* =========================================================
     SHOPIFY
  ========================================================= */

  function getShopifyRoot() {
    return (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    )
      ? window.Shopify.routes.root
      : '/';
  }


  /* =========================================================
     JSON
  ========================================================= */

  function parseJSON(
    element,
    fallback
  ) {

    if (!element) {
      return fallback;
    }


    try {

      return JSON.parse(
        element.textContent
      );

    } catch (error) {

      console.error(
        '[Lux PDP] JSON no válido',
        error
      );

      return fallback;

    }

  }


  /* =========================================================
     MONEY
  ========================================================= */

  function formatMoney(
    cents,
    locale,
    currency
  ) {

    var amount =
      (Number(cents) || 0) / 100;


    try {

      return new Intl.NumberFormat(
        locale || 'es-ES',
        {
          style:
            'currency',

          currency:
            currency || 'EUR'
        }
      ).format(
        amount
      );

    } catch (error) {

      return (
        amount
          .toFixed(2)
          .replace('.', ',') +
        ' €'
      );

    }

  }


  /* =========================================================
     INIT PDP
  ========================================================= */

  function initPage(page) {

    if (!page) {
      return;
    }


    if (
      page.dataset
        .luxPdpInitialized ===
      'true'
    ) {
      return;
    }


    page.dataset
      .luxPdpInitialized =
      'true';


    var variants =
      parseJSON(
        page.querySelector(
          '[data-lux-variants]'
        ),
        []
      );


    var form =
      page.querySelector(
        '[data-lux-product-form]'
      );


    var variantInput =
      page.querySelector(
        '[data-lux-variant-input]'
      );


    var addButton =
      page.querySelector(
        '[data-lux-add-button]'
      );


    var addButtonLabel =
      page.querySelector(
        '[data-lux-add-button-label]'
      );


    var price =
      page.querySelector(
        '[data-lux-price]'
      );


    var comparePrice =
      page.querySelector(
        '[data-lux-compare-price]'
      );


    var stock =
      page.querySelector(
        '[data-lux-stock]'
      );


    var quantityInput =
      page.querySelector(
        '[data-lux-quantity-input]'
      );


    var quantityMinus =
      page.querySelector(
        '[data-lux-quantity-minus]'
      );


    var quantityPlus =
      page.querySelector(
        '[data-lux-quantity-plus]'
      );


    var optionButtons =
      Array.prototype.slice.call(
        page.querySelectorAll(
          '[data-lux-option-button]'
        )
      );


    var mediaButtons =
      Array.prototype.slice.call(
        page.querySelectorAll(
          '[data-lux-media-button]'
        )
      );


    var mediaItems =
      Array.prototype.slice.call(
        page.querySelectorAll(
          '[data-lux-media-item]'
        )
      );


    var protectionToggle =
      page.querySelector(
        '[data-lux-protection-toggle]'
      );


    var protectionVariantId =
      Number(
        page.getAttribute(
          'data-protection-variant-id'
        )
      ) || 0;


    var message =
      page.querySelector(
        '[data-lux-message]'
      );


    var locale =
      page.getAttribute(
        'data-locale'
      ) ||
      'es-ES';


    var currency =
      page.getAttribute(
        'data-currency'
      ) ||
      'EUR';


    var lowStockLimit =
      Number(
        page.getAttribute(
          'data-low-stock-limit'
        )
      ) || 5;


    var currentVariantId =
      Number(
        page.getAttribute(
          'data-current-variant-id'
        )
      ) || 0;


    var protectionSelected =
      false;


    var selectedOptions =
      [];


    /* =======================================================
       VARIANT HELPERS
    ======================================================= */

    function getVariantById(id) {

      var target =
        Number(id);


      return (
        variants.find(
          function (variant) {

            return (
              Number(
                variant.id
              ) ===
              target
            );

          }
        ) ||
        null
      );

    }


    function getCurrentVariant() {

      return getVariantById(
        currentVariantId
      );

    }


    function getVariantOptions(
      variant
    ) {

      return [
        variant.option1,
        variant.option2,
        variant.option3
      ].filter(
        function (value) {

          return (
            value !== null &&
            typeof value !==
              'undefined'
          );

        }
      );

    }


    function findVariantByOptions() {

      return (
        variants.find(
          function (variant) {

            var options =
              getVariantOptions(
                variant
              );


            if (
              options.length !==
              selectedOptions.length
            ) {
              return false;
            }


            return options.every(
              function (
                value,
                index
              ) {

                return (
                  String(value) ===
                  String(
                    selectedOptions[
                      index
                    ]
                  )
                );

              }
            );

          }
        ) ||
        null
      );

    }


    function setSelectedOptionsFromVariant(
      variant
    ) {

      if (!variant) {
        return;
      }


      selectedOptions =
        getVariantOptions(
          variant
        );

    }


    /* =======================================================
       OPTION BUTTONS
    ======================================================= */

    function syncOptionButtons() {

      optionButtons.forEach(
        function (button) {

          var position =
            Number(
              button.getAttribute(
                'data-lux-option-position'
              )
            ) - 1;


          var value =
            button.getAttribute(
              'data-lux-option-value'
            );


          var isSelected =
            String(
              selectedOptions[
                position
              ]
            ) ===
            String(value);


          button.classList.toggle(
            'is-selected',
            isSelected
          );


          button.setAttribute(
            'aria-pressed',
            isSelected
              ? 'true'
              : 'false'
          );


          /*
            Marcamos valores sin ninguna
            variante disponible.
          */

          var hasAvailableVariant =
            variants.some(
              function (variant) {

                var options =
                  getVariantOptions(
                    variant
                  );


                return (
                  variant.available !==
                    false &&
                  String(
                    options[
                      position
                    ]
                  ) ===
                    String(value)
                );

              }
            );


          button.classList.toggle(
            'is-unavailable',
            !hasAvailableVariant
          );


          button.setAttribute(
            'aria-disabled',
            hasAvailableVariant
              ? 'false'
              : 'true'
          );

        }
      );

    }


    /* =======================================================
       GALLERY
    ======================================================= */

    function setActiveMedia(
      mediaId
    ) {

      if (!mediaId) {
        return;
      }


      var id =
        String(
          mediaId
        );


      var matched =
        false;


      mediaItems.forEach(
        function (item) {

          var isActive =
            String(
              item.getAttribute(
                'data-media-id'
              )
            ) ===
            id;


          item.classList.toggle(
            'is-active',
            isActive
          );


          item.hidden =
            !isActive;


          if (isActive) {
            matched = true;
          }

        }
      );


      mediaButtons.forEach(
        function (button) {

          var isActive =
            String(
              button.getAttribute(
                'data-media-id'
              )
            ) ===
            id;


          button.classList.toggle(
            'is-active',
            isActive
          );


          button.setAttribute(
            'aria-current',
            isActive
              ? 'true'
              : 'false'
          );

        }
      );


      if (
        !matched &&
        mediaItems.length
      ) {

        mediaItems[0].hidden =
          false;


        mediaItems[0]
          .classList
          .add(
            'is-active'
          );

      }

    }


    mediaButtons.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function () {

            setActiveMedia(
              button.getAttribute(
                'data-media-id'
              )
            );

          }
        );

      }
    );


    /* =======================================================
       STOCK
    ======================================================= */

    function updateStock(
      variant
    ) {

      if (!stock) {
        return;
      }


      stock.classList.remove(
        'is-low',
        'is-out',
        'is-in'
      );


      if (
        !variant ||
        variant.available ===
          false
      ) {

        stock.textContent =
          'Agotado';


        stock.classList.add(
          'is-out'
        );


        stock.hidden =
          false;


        return;

      }


      var managed =
        !!variant
          .inventory_management;


      var deny =
        String(
          variant
            .inventory_policy
        ) ===
        'deny';


      var quantity =
        Number(
          variant
            .inventory_quantity
        ) || 0;


      if (
        managed &&
        deny &&
        quantity > 0 &&
        quantity <=
          lowStockLimit
      ) {

        stock.textContent =
          quantity === 1
            ? 'Solo queda 1 unidad en stock'
            : 'Solo quedan ' +
              quantity +
              ' unidades en stock';


        stock.classList.add(
          'is-low'
        );

      } else {

        stock.textContent =
          'En stock';


        stock.classList.add(
          'is-in'
        );

      }


      stock.hidden =
        false;

    }


    /* =======================================================
       QUANTITY
    ======================================================= */

    function updateQuantityLimits(
      variant
    ) {

      if (!quantityInput) {
        return;
      }


      var current =
        Math.max(
          1,
          parseInt(
            quantityInput.value,
            10
          ) || 1
        );


      var max =
        null;


      if (
        variant &&
        variant.inventory_management &&
        String(
          variant.inventory_policy
        ) === 'deny' &&
        Number(
          variant.inventory_quantity
        ) > 0
      ) {

        max =
          Number(
            variant
              .inventory_quantity
          );


        current =
          Math.min(
            current,
            max
          );

      }


      quantityInput.value =
        current;


      quantityInput.min =
        '1';


      if (max) {

        quantityInput.max =
          String(max);

      } else {

        quantityInput.removeAttribute(
          'max'
        );

      }


      if (quantityMinus) {

        quantityMinus.disabled =
          current <= 1;

      }


      if (quantityPlus) {

        quantityPlus.disabled =
          max
            ? current >= max
            : false;

      }

    }


    if (
      quantityMinus &&
      quantityInput
    ) {

      quantityMinus.addEventListener(
        'click',
        function () {

          var value =
            Math.max(
              1,
              (
                parseInt(
                  quantityInput.value,
                  10
                ) || 1
              ) - 1
            );


          quantityInput.value =
            value;


          updateQuantityLimits(
            getCurrentVariant()
          );

        }
      );

    }


    if (
      quantityPlus &&
      quantityInput
    ) {

      quantityPlus.addEventListener(
        'click',
        function () {

          var value =
            (
              parseInt(
                quantityInput.value,
                10
              ) || 1
            ) + 1;


          quantityInput.value =
            value;


          updateQuantityLimits(
            getCurrentVariant()
          );

        }
      );

    }


    if (quantityInput) {

      quantityInput.addEventListener(
        'change',
        function () {

          updateQuantityLimits(
            getCurrentVariant()
          );

        }
      );

    }


    /* =======================================================
       ADD BUTTON
    ======================================================= */

    function updateAddButton(
      variant
    ) {

      if (!addButton) {
        return;
      }


      var available =
        !!variant &&
        variant.available !==
          false;


      addButton.disabled =
        !available;


      if (addButtonLabel) {

        addButtonLabel.textContent =
          available
            ? 'Añadir al carrito'
            : 'Agotado';

      }

    }


    /* =======================================================
       PRICE
    ======================================================= */

    function updatePrice(
      variant
    ) {

      if (!variant) {
        return;
      }


      var originalPrice =
        Number(
          variant.price
        ) || 0;


      var originalComparePrice =
        Number(
          variant.compare_at_price
        ) || 0;


      var displayPrice =
        originalPrice;


      var displayComparePrice =
        originalComparePrice;


      if (price) {

        price.textContent =
          formatMoney(
            displayPrice,
            locale,
            currency
          );

      }


      if (comparePrice) {

        if (
          displayComparePrice >
          displayPrice
        ) {

          comparePrice.textContent =
            formatMoney(
              displayComparePrice,
              locale,
              currency
            );


          comparePrice.hidden =
            false;

        } else {

          comparePrice.hidden =
            true;


          comparePrice.textContent =
            '';

        }

      }

    }


    /* =======================================================
       URL
    ======================================================= */

    function updateURL(
      variant
    ) {

      if (
        !variant ||
        !window.history ||
        !window.history
          .replaceState
      ) {
        return;
      }


      try {

        var url =
          new URL(
            window.location.href
          );


        url.searchParams.set(
          'variant',
          variant.id
        );


        window.history.replaceState(
          {},
          '',
          url.toString()
        );

      } catch (error) {

        /*
          No bloqueamos el selector
          por un error de URL.
        */

      }

    }


    /* =======================================================
       APPLY VARIANT
    ======================================================= */

    function applyVariant(
      variant,
      options
    ) {

      options =
        options || {};


      if (!variant) {

        updateAddButton(
          null
        );


        if (message) {

          message.textContent =
            'Esta combinación no está disponible.';

        }


        return;

      }


      currentVariantId =
        Number(
          variant.id
        );


      page.setAttribute(
        'data-current-variant-id',
        String(
          currentVariantId
        )
      );


      if (variantInput) {

        variantInput.value =
          String(
            currentVariantId
          );

      }


      setSelectedOptionsFromVariant(
        variant
      );


      syncOptionButtons();


      updatePrice(
        variant
      );


      updateStock(
        variant
      );


      updateQuantityLimits(
        variant
      );


      updateAddButton(
        variant
      );


      if (message) {

        message.textContent =
          '';

      }


      if (
        variant
          .featured_media_id
      ) {

        setActiveMedia(
          variant
            .featured_media_id
        );

      }


      if (
        options.updateUrl !==
        false
      ) {

        updateURL(
          variant
        );

      }

    }


    /* =======================================================
       VARIANT OPTIONS
    ======================================================= */

    optionButtons.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function () {

            if (
              button.getAttribute(
                'aria-disabled'
              ) ===
              'true'
            ) {
              return;
            }


            var position =
              Number(
                button.getAttribute(
                  'data-lux-option-position'
                )
              ) - 1;


            selectedOptions[
              position
            ] =
              button.getAttribute(
                'data-lux-option-value'
              );


            syncOptionButtons();


            var variant =
              findVariantByOptions();


            applyVariant(
              variant
            );

          }
        );

      }
    );


    /* =======================================================
       PROTECTION
    ======================================================= */

    if (protectionToggle) {

      protectionToggle.addEventListener(
        'click',
        function () {

          protectionSelected =
            !protectionSelected;


          protectionToggle.classList.toggle(
            'is-selected',
            protectionSelected
          );


          protectionToggle.setAttribute(
            'aria-pressed',
            protectionSelected
              ? 'true'
              : 'false'
          );


          protectionToggle.textContent =
            protectionSelected
              ? '−'
              : '+';


          protectionToggle.setAttribute(
            'aria-label',
            protectionSelected
              ? 'Quitar protección de pantalla'
              : 'Añadir protección de pantalla'
          );

        }
      );

    }


    /* =======================================================
       MESSAGE
    ======================================================= */

    function setMessage(
      text,
      isError
    ) {

      if (!message) {
        return;
      }


      message.textContent =
        text || '';


      message.classList.toggle(
        'is-error',
        !!isError
      );


      message.classList.toggle(
        'is-success',
        !isError &&
        !!text
      );

    }


    /* =======================================================
       LOADING
    ======================================================= */

    function setLoading(
      loading
    ) {

      if (!addButton) {
        return;
      }


      if (loading) {

        addButton.setAttribute(
          'aria-busy',
          'true'
        );


        addButton.disabled =
          true;


        if (addButtonLabel) {

          addButtonLabel.textContent =
            'Añadiendo...';

        }

      } else {

        addButton.removeAttribute(
          'aria-busy'
        );


        updateAddButton(
          getCurrentVariant()
        );

      }

    }


    /* =======================================================
       AJAX CART
    ======================================================= */

    function addToCart(
      items
    ) {

      return fetch(
        getShopifyRoot() +
          'cart/add.js',
        {
          method:
            'POST',

          credentials:
            'same-origin',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          body:
            JSON.stringify({
              items:
                items
            })
        }
      )
        .then(
          function (response) {

            if (
              !response.ok
            ) {

              return response
                .json()
                .catch(
                  function () {
                    return {};
                  }
                )
                .then(
                  function (data) {

                    throw new Error(
                      data.description ||
                      data.message ||
                      'No se ha podido añadir el producto.'
                    );

                  }
                );

            }


            return response.json();

          }
        );

    }


    /* =======================================================
       FORM SUBMIT
    ======================================================= */

    if (form) {

      form.addEventListener(
        'submit',
        function (event) {

          event.preventDefault();


          var variant =
            getCurrentVariant();


          if (
            !variant ||
            variant.available ===
              false
          ) {
            return;
          }


          var quantity =
            quantityInput
              ? Math.max(
                  1,
                  parseInt(
                    quantityInput.value,
                    10
                  ) || 1
                )
              : 1;


          var items = [
            {
              id:
                Number(
                  variant.id
                ),

              quantity:
                quantity
            }
          ];


          /*
            Si el usuario ha pulsado +
            añadimos también el protector.
          */

          if (
            protectionSelected &&
            protectionVariantId
          ) {

            items.push({
              id:
                protectionVariantId,

              quantity:
                quantity
            });

          }


          setMessage(
            '',
            false
          );


          setLoading(
            true
          );


          addToCart(
            items
          )
            .then(
              function () {

                window.location.href =
                  getShopifyRoot() +
                  'cart';

              }
            )
            .catch(
              function (error) {

                console.error(
                  '[Lux PDP] Error al añadir al carrito',
                  error
                );


                setLoading(
                  false
                );


                setMessage(
                  error.message ||
                  'No se ha podido añadir el producto. Inténtalo de nuevo.',
                  true
                );

              }
            );

        }
      );

    }


    /* =======================================================
       INITIAL VARIANT
    ======================================================= */

    var initialVariant =
      getVariantById(
        currentVariantId
      ) ||
      variants[0] ||
      null;


    if (initialVariant) {

      applyVariant(
        initialVariant,
        {
          updateUrl:
            false
        }
      );

    }


    /* =======================================================
       DELIVERY
    ======================================================= */

    initDeliveryCountdown(
      page
    );

  }


  /* =========================================================
     DELIVERY CALCULATIONS
  ========================================================= */

  function getZonedParts(
    date,
    timeZone
  ) {

    var formatter =
      new Intl.DateTimeFormat(
        'en-GB',
        {
          timeZone:
            timeZone,

          year:
            'numeric',

          month:
            '2-digit',

          day:
            '2-digit',

          hour:
            '2-digit',

          minute:
            '2-digit',

          second:
            '2-digit',

          hourCycle:
            'h23'
        }
      );


    var result =
      {};


    formatter
      .formatToParts(
        date
      )
      .forEach(
        function (part) {

          if (
            part.type !==
            'literal'
          ) {

            result[
              part.type
            ] =
              Number(
                part.value
              );

          }

        }
      );


    return result;

  }


  function getTimeZoneOffset(
    date,
    timeZone
  ) {

    var parts =
      getZonedParts(
        date,
        timeZone
      );


    return (
      Date.UTC(
        parts.year,
        parts.month - 1,
        parts.day,
        parts.hour,
        parts.minute,
        parts.second
      ) -
      date.getTime()
    );

  }


  function zonedTimeToUtc(
    year,
    month,
    day,
    hour,
    minute,
    second,
    timeZone
  ) {

    var utc =
      Date.UTC(
        year,
        month - 1,
        day,
        hour,
        minute,
        second
      );


    for (
      var index = 0;
      index < 3;
      index += 1
    ) {

      utc =
        Date.UTC(
          year,
          month - 1,
          day,
          hour,
          minute,
          second
        ) -
        getTimeZoneOffset(
          new Date(utc),
          timeZone
        );

    }


    return new Date(
      utc
    );

  }


  function makeCalendarDate(
    year,
    month,
    day
  ) {

    return new Date(
      Date.UTC(
        year,
        month - 1,
        day,
        12,
        0,
        0
      )
    );

  }


  function addCalendarDays(
    date,
    amount
  ) {

    var result =
      new Date(
        date.getTime()
      );


    result.setUTCDate(
      result.getUTCDate() +
      amount
    );


    return result;

  }


  function isBusinessDay(
    date
  ) {

    var weekday =
      date.getUTCDay();


    return (
      weekday >= 1 &&
      weekday <= 5
    );

  }


  function nextBusinessDay(
    date
  ) {

    var result =
      addCalendarDays(
        date,
        1
      );


    while (
      !isBusinessDay(
        result
      )
    ) {

      result =
        addCalendarDays(
          result,
          1
        );

    }


    return result;

  }


  function formatDeliveryDay(
    deliveryDate
  ) {

    return new Intl.DateTimeFormat(
      'es-ES',
      {
        weekday:
          'long',

        timeZone:
          'UTC'
      }
    ).format(
      deliveryDate
    );

  }


  function formatDeliveryDate(
    deliveryDate
  ) {

    return new Intl.DateTimeFormat(
      'es-ES',
      {
        day:
          'numeric',

        month:
          'long',

        timeZone:
          'UTC'
      }
    ).format(
      deliveryDate
    );

  }


  function formatCountdown(
    milliseconds
  ) {

    var totalSeconds =
      Math.max(
        0,
        Math.floor(
          milliseconds /
          1000
        )
      );


    var hours =
      Math.floor(
        totalSeconds /
        3600
      );


    var minutes =
      Math.floor(
        (
          totalSeconds %
          3600
        ) /
        60
      );


    var seconds =
      totalSeconds %
      60;


    if (
      hours > 0
    ) {

      return (
        hours +
        ' h ' +
        String(minutes)
          .padStart(
            2,
            '0'
          ) +
        ' min'
      );

    }


    return (
      minutes +
      ' min ' +
      String(seconds)
        .padStart(
          2,
          '0'
        ) +
      ' s'
    );

  }


  function calculateDelivery(
    now,
    timeZone,
    cutoffHour
  ) {

    var parts =
      getZonedParts(
        now,
        timeZone
      );


    var today =
      makeCalendarDate(
        parts.year,
        parts.month,
        parts.day
      );


    var beforeCutoff =
      isBusinessDay(
        today
      ) &&
      (
        parts.hour <
          cutoffHour ||

        (
          parts.hour ===
            cutoffHour &&
          parts.minute === 0 &&
          parts.second === 0
        )
      );


    var processingDate =
      beforeCutoff
        ? today
        : nextBusinessDay(
            today
          );


    var deliveryDate =
      nextBusinessDay(
        processingDate
      );


    var cutoffDate =
      beforeCutoff
        ? today
        : nextBusinessDay(
            today
          );


    var cutoffAt =
      zonedTimeToUtc(
        cutoffDate
          .getUTCFullYear(),

        cutoffDate
          .getUTCMonth() + 1,

        cutoffDate
          .getUTCDate(),

        cutoffHour,

        0,

        0,

        timeZone
      );


    return {
      deliveryDate:
        deliveryDate,

      cutoffAt:
        cutoffAt
    };

  }


  /* =========================================================
     DELIVERY INIT
  ========================================================= */

  function initDeliveryCountdown(
    page
  ) {

    var element =
      page.querySelector(
        '[data-lux-delivery-countdown]'
      );


    if (!element) {
      return;
    }


    if (
      element.dataset
        .luxDeliveryInitialized ===
      'true'
    ) {
      return;
    }


    element.dataset
      .luxDeliveryInitialized =
      'true';


    var dayElement =
      element.querySelector(
        '[data-lux-delivery-day]'
      );


    var dateElement =
      element.querySelector(
        '[data-lux-delivery-date]'
      );


    var timerElement =
      element.querySelector(
        '[data-lux-delivery-timer]'
      );


    var cutoffHour =
      Number(
        element.getAttribute(
          'data-cutoff-hour'
        )
      ) || 15;


    var timeZone =
      element.getAttribute(
        'data-time-zone'
      ) ||
      'Europe/Madrid';


    var timerId =
      null;


    function update() {

      var now =
        new Date();


      var data =
        calculateDelivery(
          now,
          timeZone,
          cutoffHour
        );


      if (dayElement) {

        dayElement.textContent =
          formatDeliveryDay(
            data.deliveryDate
          );

      }


      if (dateElement) {

        dateElement.textContent =
          formatDeliveryDate(
            data.deliveryDate
          );

      }


      if (timerElement) {

        timerElement.textContent =
          formatCountdown(
            data.cutoffAt
              .getTime() -
            now.getTime()
          );

      }

    }


    function start() {

      if (timerId) {
        return;
      }


      update();


      timerId =
        window.setInterval(
          update,
          1000
        );

    }


    function stop() {

      if (!timerId) {
        return;
      }


      window.clearInterval(
        timerId
      );


      timerId =
        null;

    }


    document.addEventListener(
      'visibilitychange',
      function () {

        if (
          document.hidden
        ) {

          stop();

        } else {

          start();

        }

      }
    );


    start();


    element
      ._luxDeliveryStop =
      stop;

  }


  /* =========================================================
     INIT ALL
  ========================================================= */

  function initAll(
    scope
  ) {

    var context =
      scope ||
      document;


    context
      .querySelectorAll(
        PAGE_SELECTOR
      )
      .forEach(
        initPage
      );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initAll(
          document
        );

      }
    );

  } else {

    initAll(
      document
    );

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initAll(
        event.target
      );

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      event.target
        .querySelectorAll(
          '[data-lux-delivery-countdown]'
        )
        .forEach(
          function (element) {

            if (
              element
                ._luxDeliveryStop
            ) {

              element
                ._luxDeliveryStop();

            }

          }
        );

    }
  );

})();